import React from 'react';
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { styles } from '@tag/tag-components-react-v2';
import { Doc } from '../../Docs/DocTypes';
import { getCssForGroupButton } from './NavUtils';
type NavGroupProps = {
  doc: Doc;
  selected: boolean;
  onClick: (doc: Doc) => void;
  docsDarkModeValue: boolean;
};
export const NavGroup: React.FC<NavGroupProps> = ({
  doc,
  selected,
  onClick,
  docsDarkModeValue,
}) => {
  return (
    <button
      css={getCssForGroupButton(selected, styles.font.family, docsDarkModeValue)}
      onClick={() => onClick(doc)}
    >
      {doc.name}
    </button>
  );
};
